import {ResourceTypes} from '../../shared/constants/resource-types';

export const RESOURCE_TYPES = {
  Facility: 'facility',
  Human: 'human',
  System: 'system',
  'Platform / Capability': 'platform',
  Industry: 'industry',
  Flow: 'flow',
  Object: 'object'
} as const;

export const DISPLAY_RESOURCE_TYPES = {
  facility: ResourceTypes.Facility,
  human: ResourceTypes.Human,
  system: ResourceTypes.System,
  platform: ResourceTypes['Platform / Capability'],
  industry: ResourceTypes.Industry,
  flow: ResourceTypes.Flow,
  object: ResourceTypes.Object
} as const;

export const RASCI_TYPES = [
  {
    key: 'responsible',
    label: 'Responsible'
  },
  {
    key: 'accountable',
    label: 'Accountable'
  },
  {
    key: 'supporting',
    label: 'Supporting'
  },
  {
    key: 'consulted',
    label: 'Consulted'
  },
  {
    key: 'informed',
    label: 'Informed'
  }
] as const;
